import { Component, OnInit, ViewChild, ErrorHandler } from '@angular/core';

import { Http, Response } from '@angular/http';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError, config } from 'rxjs';

import { NgbModal, ModalDismissReasons, NgbDropdownConfig, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { browser } from 'protractor';

import { NgForm, FormGroup } from '@angular/forms';

import { ifError } from 'assert';

import { UserService } from '../services/user.service';
import { User } from 'models/user.model';

import { ToastContainerDirective, ToastrService, ToastContainerModule } from 'ngx-toastr';
import { LocalStorage } from 'ngx-webstorage';
import { error } from '@angular/compiler/src/util';


@Component({
  selector: 'app-modal-forgot-password',
  templateUrl: './modal-forgot-password.component.html',
  styleUrls: ['./modal-forgot-password.component.css']
})
export class ModalForgotPasswordComponent implements OnInit {

  Email: string;
  Username: string;
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  constructor
    (
    private modalService: NgbModal,
    private router: Router,
    private translate: TranslateService,
    private userService: UserService,
    private toastr: ToastrService,
    private config: NgbDropdownConfig,
     private modal: NgbActiveModal
  )
  { }

  ngOnInit() {
  }

  close() {
    this.modal.close()
  }

  OnSubmit(Email, Username) {
    this.userService.forgotPassword(Email, Username)
      .subscribe(
      data => {
        this.translate.get('FORGOT_PASSWORD_200.TITLE').subscribe((res: string) => {
          this.toastr.success(res, null, {
            positionClass: 'toast-top-center',
            timeOut: 2000
          })
        });
        this.close();
      },
      error => {
        if (error.status == 404) {
          this.translate.get('FORGOT_PASSWORD_404.TITLE').subscribe((res: string) => {
            this.toastr.error(res, null, {
              positionClass: 'toast-top-center',
              timeOut: 2000
            })
          });

        } else if (error.status == 406) {
          this.translate.get('FORGOT_PASSWORD_406.TITLE').subscribe((res: string) => {
            this.toastr.error(res, null, {
              positionClass: 'toast-top-center',
              timeOut: 2000
            })
          });

        } else {
          this.router.navigate(['/errorPage']);
        }
      });
  }
}
